import React from 'react'
import { Container } from './styled'

interface Props {
  imageUrl: string
}

export const MediaPlaceholder: React.FC<Props> = ({ imageUrl }) => {
  return (
    <Container>
      <div
        style={{ backgroundImage: `url(${imageUrl})` }}
      />
    </Container>
  )
}
